import React from "react";

export default function CopyStep6() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          6
        </div>
        <h1 className="">
          Insira o código <b>MON123</b>, conforme print abaixo:
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px] flex items-start gap-1.5 flex-wrap">
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/ShbPGe0720161.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
